<template>
  <div class="board-new-section">
    <v-container>
      <div class="d-flex justify-space-between align-center mb-6">
        <h2 class="section-title">กระดานข่าวแนะนำ</h2>
        <v-btn color="black" dark rounded small elevation="0" @click="goMore" class="px-4">
          ดูเพิ่มเติม
        </v-btn>
      </div>

      <div v-if="isLoading" class="d-flex justify-center py-12">
        <v-progress-circular indeterminate size="32" width="3" color="primary" />
      </div>

      <div v-else-if="items.length === 0" class="text-center py-12 grey--text">
        ยังไม่พบข่าวแนะนำ
      </div>

      <v-row v-else class="row-gap-24">
        <v-col v-for="item in items" :key="item.id" cols="12" sm="6" md="3">
          <div class="board-card" @click="goDetail(item.id)">
            <div class="board-image-wrapper">
              <v-img :src="toImageUrl(item.image)" aspect-ratio="1.2" cover class="board-image">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
            <div class="board-content pt-3">
              <h3 class="board-title text-truncate-2">{{ item.title }}</h3>
              <div class="board-meta mt-1">
                <span>{{ formatTimeAgo(item.publishedAt) }}</span>
                <template v-if="item.views">
                  <span class="meta-sep">·</span>
                  <v-icon size="11" color="#aaa">mdi-eye-outline</v-icon>
                  <span>{{ formatViews(item.views) }}</span>
                </template>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "BoardNew",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toImageUrl(path) {
      console.log(path);
      
      if (!path) return "https://placehold.co/400x300?text=No+Image";
      if (path.startsWith("http")) return path;
      const base = process.env.VUE_APP_API_URL || "";
      return `${base}${path}`;
    },
    formatTimeAgo(dateStr) {
      if (!dateStr) return "";
      const published = new Date(dateStr);
      const now = new Date();
      const diffMs = now - published;
      if (diffMs <= 0) return "เมื่อสักครู่";

      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      if (diffMinutes < 60) return `${diffMinutes} นาทีที่แล้ว`;

      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      if (diffHours < 24) return `${diffHours} ชั่วโมงที่แล้ว`;

      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      if (diffDays < 7) return `${diffDays} วันที่แล้ว`;

      const weeks = Math.floor(diffDays / 7);
      if (weeks < 4) return `${weeks} สัปดาห์ที่แล้ว`;

      const months = Math.floor(diffDays / 30);
      if (months < 12) return `${months} เดือนที่แล้ว`;

      const years = Math.floor(diffDays / 365);
      return `${years} ปีที่แล้ว`;
    },
    goMore() {
      this.$router.push({ name: "BoardList" });
    },
    formatViews(n) {
      if (!n) return '0';
      if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
      return String(n);
    },
    goDetail(id) {
      this.$router.push({ name: "BoardDetail", params: { boardId: id } });
    },
  },
};
</script>

<style scoped>
.board-new-section {
  padding: 60px 0;
  max-width: 1440px;
  margin: 0 auto;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #000;
}

.board-card {
  cursor: pointer;
  height: 100%;
  transition: transform 0.2s;
}

.board-card:hover {
  transform: translateY(-4px);
}

.board-image-wrapper {
  overflow: hidden;
  border-radius: 4px;
  background-color: #f5f5f5;
}

.board-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: #000;
}

.board-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #888;
}
.meta-sep {
  color: #ccc;
}

.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
